import {
  ChecklistComplementaryItemPosition,
  checklistComplementaryItems,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.ComplementaryItemsConstant';
import {
  ChecklistComplementItemResponse,
  ReportChecklistData,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

interface Props {
  checklist: ReportChecklistData;
}

type ComplementaryItem = typeof checklistComplementaryItems[0];

const tableTitle = {
  [ChecklistComplementaryItemPosition.Ground]: 'Veículo no chão',
  [ChecklistComplementaryItemPosition.Lift]: 'Veículo no elevador',
  [ChecklistComplementaryItemPosition.TestRun]:
    'Inspeção final e teste de rodagem',
};

const ReportChecklistComplementItems: React.FC<Props> = ({ checklist }) => {
  const complementItemsGround = checklistComplementaryItems.filter(
    (item) => item.position === ChecklistComplementaryItemPosition.Ground,
  );

  const complementItemsLift = checklistComplementaryItems.filter(
    (item) => item.position === ChecklistComplementaryItemPosition.Lift,
  );

  const complementItemsTestRun = checklistComplementaryItems.filter(
    (item) => item.position === ChecklistComplementaryItemPosition.TestRun,
  );

  const tables = {
    [ChecklistComplementaryItemPosition.Ground]:
      complementItemsGround.map(renderRow),
    [ChecklistComplementaryItemPosition.Lift]:
      complementItemsLift.map(renderRow),
    [ChecklistComplementaryItemPosition.TestRun]:
      complementItemsTestRun.map(renderRow),
  };

  function getComplement(value: string) {
    return checklist.complementaryItems?.find(
      (item) => item.description === value,
    );
  }

  function renderRow(item: ComplementaryItem) {
    const complement = getComplement(item.value);

    return (
      <tr key={item.value}>
        <td>{item.label}</td>
        <td>
          {complement?.response === ChecklistComplementItemResponse.Ok && (
            <span className="icon-ok">&#9745;</span>
          )}
        </td>
        <td>
          {complement?.response === ChecklistComplementItemResponse.NotOk && (
            <span className="icon-notOk">&#9746;</span>
          )}
        </td>
        <td>
          {complement?.response === ChecklistComplementItemResponse.Warning && (
            <span className="icon-warning">&#9888;</span>
          )}
        </td>
        <td>{complement?.comment}</td>
      </tr>
    );
  }

  function renderTable(type: ChecklistComplementaryItemPosition) {
    return (
      <table className="reportChecklist-complementItems-table">
        <thead>
          <tr>
            <th>{tableTitle[type]}</th>
            <th>Ok</th>
            <th>Não Ok</th>
            <th>Atenção</th>
            <th>Observação</th>
          </tr>
        </thead>

        <tbody>{tables[type]}</tbody>
      </table>
    );
  }

  return (
    <div className="reportChecklist-complementItems">
      <div
        className={`reportChecklist-complementItems-header  ${
          checklist.company?.bosch ? '-bosch' : ''
        }`}
      >
        <span>Checklist complementar</span>
      </div>

      <div>{renderTable(ChecklistComplementaryItemPosition.Ground)}</div>
      <div>{renderTable(ChecklistComplementaryItemPosition.Lift)}</div>
      <div>{renderTable(ChecklistComplementaryItemPosition.TestRun)}</div>
    </div>
  );
};

export default ReportChecklistComplementItems;
